export type Color = "Red" | "Green" | "Yellow" | "Blue" | "Magenta" | "Cyan" | "White";

const ANSI: Record<Color, number> = {
    Red: 31, Green: 32, Yellow: 33, Blue: 34,
    Magenta: 35, Cyan: 36, White: 37,
};

const timestamp = (): string => `[LOG] - ${new Date().toLocaleString()}    `;

export const Logger = {
    disabled: false,

    log(msg: string, color: Color = "White"): void {
        if (this.disabled) return;
        console.log(`%s\x1b[${ANSI[color]}m%s\x1b[0m`, timestamp(), msg);
    },
    error(msg: string): void {
        if (this.disabled) return;
        console.log(`%s\x1b[31m%s\x1b[0m`, timestamp(), msg);
    },
    warn(msg: string): void {
        if (this.disabled) return;
        console.log(`%s\x1b[33m%s\x1b[0m`, timestamp(), msg);
    },
    succ(msg: string): void {
        if (this.disabled) return;
        console.log(`%s\x1b[32m%s\x1b[0m`, timestamp(), msg);
    },
    /**
     * Renders a progress bar to stdout.
     * @param current Current progress value.
     * @param total Total value.
     * @param sameLine Overwrite the current line instead of printing a new one.
     */
    nodeProgress(current: number, total: number, sameLine: boolean = false): void {
        const percent = current / total;
        const barLen = 20;
        const filled = Math.round(barLen * percent);
        const empty = barLen - filled;

        let bar = filled > 1 ? "❤️".repeat(filled - 1) + "🐰" : "🐰";
        if (empty > 0) bar += "  ".repeat(empty - 1) + "🥕";

        const text = `[${bar}] ${Math.round(percent * 100)}%`;

        if (sameLine) {
            process.stdout.clearLine(0);
            process.stdout.cursorTo(0);
            process.stdout.write(text);
            if (percent >= 1) process.stdout.write("\n");
        } else {
            console.log(text);
        }
    },
};

